import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../config/site';
import { api, displayNombre, formatCOP, imageUrl } from '../services/api';

const MAP_SRC =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15864.9330354521!2d-75.57038489079213!3d6.232951481032854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e4428f885b80c3b%3A0x4dba4c4fab1158d1!2sedificio%20escobar%20saldarriaga!5e0!3m2!1ses!2sco!4v1724918724756!5m2!1ses!2sco';

const INTRO =
  '¡Estamos aquí para ayudarte! En Oh Belleza, tu satisfacción es nuestra prioridad. Si tienes alguna pregunta, necesitas asistencia con tu pedido, o simplemente deseas conocer más sobre nuestros productos, no dudes en contactarnos. Estaremos encantados de atenderte y resolver cualquier inquietud que tengas. ¡Estamos a un clic de distancia!';

export default function Contact() {
  const [form, setForm] = useState({ nombre: '', email: '', telefono: '', mensaje: '' });
  const [sent, setSent] = useState(false);
  const [nuevos, setNuevos] = useState([]);

  React.useEffect(() => {
    let cancelled = false;
    api
      .getProductos({ limit: 8 })
      .then((r) => {
        if (!cancelled) setNuevos((r.data || []).filter((p) => p.imagen).slice(0, 6));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  function onChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  }

  function onSubmit(e) {
    e.preventDefault();
    const subject = `Contacto web — ${form.nombre}`;
    const body = [
      `Nombre: ${form.nombre}`,
      `Email: ${form.email}`,
      `Teléfono: ${form.telefono}`,
      '',
      form.mensaje,
    ].join('\n');
    const mailto = `mailto:${SITE.contactEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailto;
    setSent(true);
  }

  return (
    <div className="contact-page">
      <section className="contact-map">
        <iframe
          title="Edificio Escobar Saldarriaga — ¡Oh! Belleza"
          src={MAP_SRC}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </section>

      <section className="contact-body">
        <div className="contact-grid">
          <div className="contact-info">
            <h1>Información de contacto</h1>
            <p className="contact-intro">{INTRO}</p>

            <ul className="contact-details">
              <li>
                <span className="contact-ico" aria-hidden>
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M3 10.5L12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1v-9.5z" />
                  </svg>
                </span>
                <div>
                  <strong>Dirección</strong>
                  <p>{SITE.addressShort}</p>
                </div>
              </li>
              <li>
                <span className="contact-ico" aria-hidden>
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 7v6l4 2" />
                  </svg>
                </span>
                <div>
                  <strong>Horario</strong>
                  {SITE.hoursLines.map((line) => (
                    <p key={line}>{line}</p>
                  ))}
                </div>
              </li>
              <li>
                <span className="contact-ico" aria-hidden>
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M6.6 10.8a15.5 15.5 0 006.6 6.6l2.2-2.2a1 1 0 011-.24c1.1.37 2.3.56 3.5.56a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.2.19 2.4.56 3.5a1 1 0 01-.25 1L6.6 10.8z" />
                  </svg>
                </span>
                <div>
                  <strong>Teléfonos</strong>
                  <p>
                    {SITE.phones.map((p, i) => (
                      <React.Fragment key={p}>
                        {i > 0 ? ' | ' : null}
                        <a href={`tel:+57${p}`}>+57 {p.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4')}</a>
                      </React.Fragment>
                    ))}
                  </p>
                </div>
              </li>
              <li>
                <span className="contact-ico" aria-hidden>
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M4 6h16v12H4z" />
                    <path d="M4 6l8 7 8-7" />
                  </svg>
                </span>
                <div>
                  <strong>Email</strong>
                  <p>
                    <a href={`mailto:${SITE.contactEmail}`}>{SITE.contactEmail}</a>
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div className="contact-form-wrap">
            <h2>¿Necesitas soporte?</h2>
            <p className="contact-form-note">
              Tu dirección de correo electrónico no será publicada. Los campos requeridos están marcados con *
            </p>

            {sent ? (
              <div className="contact-sent">
                <strong>¡Gracias!</strong>
                <p>
                  Se abrió tu correo para enviar el mensaje a {SITE.contactEmail}. Si no se abrió, escríbenos
                  directo a ese correo.
                </p>
              </div>
            ) : null}

            <form className="contact-form" onSubmit={onSubmit}>
              <label>
                Nombre <em>*</em>
                <input name="nombre" value={form.nombre} onChange={onChange} placeholder="Nombre *" required />
              </label>
              <label>
                Email <em>*</em>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={onChange}
                  placeholder="Email *"
                  required
                />
              </label>
              <label>
                Teléfono <em>*</em>
                <input
                  name="telefono"
                  value={form.telefono}
                  onChange={onChange}
                  placeholder="Teléfono *"
                  required
                />
              </label>
              <label>
                Mensaje <em>*</em>
                <textarea
                  name="mensaje"
                  value={form.mensaje}
                  onChange={onChange}
                  placeholder="Mensaje *"
                  rows={5}
                  required
                />
              </label>
              <button type="submit" className="contact-submit">
                Enviar mensaje
              </button>
            </form>
          </div>
        </div>
      </section>

      {nuevos.length ? (
        <section className="contact-nuevos section">
          <div className="section-head centered">
            <p className="section-kicker">Catálogo</p>
            <h2>Nuevos productos</h2>
            <p>Descubre nuestras últimas novedades</p>
          </div>
          <div className="contact-nuevos-grid">
            {nuevos.map((p) => {
              const img = imageUrl(p.imagen);
              const name = displayNombre(p) || `Cód. ${p.codigo}`;
              return (
                <Link key={p.codigo} to="/catalogo" className="contact-nuevo-card">
                  <div className="contact-nuevo-img">{img ? <img src={img} alt={name} loading="lazy" /> : null}</div>
                  <strong>{name}</strong>
                  <span>{formatCOP(p.precio)}</span>
                </Link>
              );
            })}
          </div>
        </section>
      ) : null}
    </div>
  );
}
